import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Newsletters.css';

const Newsletters = () => {
  return (
    <>
      <Helmet>
        <title>Newsletters - Daily Business & Market Updates | Redbox Global</title>
        <meta name="description" content="Subscribe to Redbox Global newsletters for curated business news, market insights, and expert analysis delivered to your inbox. Daily, weekly, and specialized newsletters available." />
        <meta name="keywords" content="business newsletters, market updates, email newsletters, daily briefing, business news email, market analysis newsletter, financial newsletters, subscribe newsletters" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/newsletters" />
        <meta property="og:title" content="Newsletters - Daily Business & Market Updates | Redbox Global" />
        <meta property="og:description" content="Subscribe to curated business news, market insights, and expert analysis delivered to your inbox daily." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/newsletters" />
        <meta name="twitter:title" content="Newsletters - Daily Business & Market Updates | Redbox Global" />
        <meta name="twitter:description" content="Subscribe to curated business news, market insights, and expert analysis delivered to your inbox daily." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/newsletters" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Newsletters</h1>
          <p className="page-subtitle">Stay informed with curated insights delivered directly to your inbox</p>
        </div>
        
        <div className="page-content">
          <a href="/article/daily-briefing-newsletter" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=600&fit=crop" alt="Newsletter subscription" />
              </div>
              <div className="featured-content">
               
                <h2>The Daily Briefing</h2>
                <p>Start your day informed with our flagship newsletter. Get the top business stories, market movers, and essential insights you need to know before the opening bell. Delivered to 2 million+ subscribers every weekday morning at 6 AM ET.</p>
                <span className="article-meta">Daily • Weekdays • Free</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/markets-wrap-newsletter" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Markets newsletter" />
                </div>
                <div className="article-content">
                  
                  <h2>Markets Wrap: End-of-Day Analysis</h2>
                  <p>Essential market insights and analysis delivered every trading day at market close.</p>
                  <span className="article-meta">Daily • 4:30 PM ET • Free</span>
                </div>
              </article>
            </a>

            <a href="/article/tech-weekly-newsletter" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop" alt="Tech newsletter" />
                </div>
                <div className="article-content">
                
                  <h2>Tech Insider: Weekly Innovation Report</h2>
                  <p>Deep dives into the technologies and startups shaping tomorrow's business landscape.</p>
                  <span className="article-meta">Weekly • Thursdays • Free</span>
                </div>
              </article>
            </a>

            <a href="/article/wealth-strategies-newsletter" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop" alt="Wealth newsletter" />
                </div>
                <div className="article-content">
                
                  <h2>Wealth Strategies & Investment Ideas</h2>
                  <p>Exclusive insights on portfolio management, investment opportunities, and wealth preservation.</p>
                  <span className="article-meta">Bi-Weekly • Premium</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletters;
